import React, { Component } from 'react';
import './UploadDrugOrderFormImagePopup.css';
import Popup from '../../components/popup/Popup';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Button from '../../components/button/Button';
import mainAPI from '../../api/MainAPI';
import toasts from '../../utils/toasts';

export default class UploadDrugOrderFormImagePopup extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uploading: false
		};
		this.fileInputRef = React.createRef();
	}

	_handleFileSelect = () => {
		if (this.fileInputRef.current) {
			this.fileInputRef.current.click();
		}
	};

	_handleFileChange = async (event) => {
		const file = event.target.files?.[0];
		if (!file) return;

		const { drug_order_form_id, onComplete } = this.props;
		if (!drug_order_form_id) {
			toasts.show('Invalid drug order form ID');
			return;
		}

		this.setState({ uploading: true });

		const formData = new FormData();
		formData.append('file', file);
		formData.append('drug_order_form_id', drug_order_form_id);

		try {
			await mainAPI.drug_order_form_image.upload(formData);
			toasts.show('Image uploaded successfully');
			if (onComplete) {
				onComplete();
			}
			this.props.onClose();
		} catch (error) {
			console.error('Error uploading image:', error);
			toasts.show('Failed to upload image');
		} finally {
			this.setState({ uploading: false });
			if (this.fileInputRef.current) {
				this.fileInputRef.current.value = '';
			}
		}
	};

	render() {
		const { uploading } = this.state;
		const { onClose, show } = this.props;
		let showProp = show;
		if (!this.props.hasOwnProperty('show')) {
			showProp = true;
		}

		return (
			<Popup {...this.props} show={showProp} className="upload-drug-order-form-image-popup">
				<Card>
					<Label black large className="upload-drug-order-form-image-popup-label">
						Upload Drug Order Form Image
					</Label>
					<div className="upload-drug-order-form-image-popup-content">
						<input
							ref={this.fileInputRef}
							type="file"
							accept="image/*"
							style={{ display: 'none' }}
							onChange={this._handleFileChange}
						/>
						<Button
							color="white"
							bg="blue"
							onClick={this._handleFileSelect}
							disabled={uploading}
						>
							{uploading ? 'Uploading...' : 'Select Image'}
						</Button>
					</div>
					<div className="upload-drug-order-form-image-popup-actions">
						<Button color="white" bg="red" onClick={onClose}>
							Cancel
						</Button>
					</div>
				</Card>
			</Popup>
		);
	}
}




// WEBPACK FOOTER //
// ./src/popups/uploadDrugOrderFormImagePopup/UploadDrugOrderFormImagePopup.jsx